import { useMutation } from '@apollo/client/react';
export { useMutation } from '@apollo/client/react';
export const useFederatedMutation = (mutation, options = {}) => {
    return useMutation(mutation, Object.assign(Object.assign({}, options), { context: Object.assign(Object.assign({}, (options.context || {})), { clientName: 'external' }) }));
};
export const useSecureFederatedMutation = (mutation, options = {}) => {
    return useMutation(mutation, Object.assign(Object.assign({}, options), { context: Object.assign(Object.assign({}, (options.context || {})), { clientName: 'secure' }) }));
};
